import type { ComponentType } from 'preact';
import { lazy } from 'preact-iso';

import { Button } from '@amumin/ui';

import { EmptyState } from '../lib/EmptyState.js';
import { loadOrFallback } from '../lib/chunkLoad.js';
import { appText, messages } from '../state/session.js';

/** Even "laden" tot de pagina herlaadt (nooit een leeg midden). */
function ReloadingPage() {
  return <p class="page-loading">{messages.value.web.loading}</p>;
}

/** Het scherm laadde niet, ook niet na herladen: rustig zeggen en één knop om opnieuw te laden. */
function ChunkErrorPage() {
  const a = appText.value;
  return (
    <EmptyState
      title={a.crashTitle}
      body={a.crashBody}
      name="page-load-failed"
      action={
        <Button
          name="reload"
          variant="primary"
          icon="refresh-cw"
          onPress={() => window.location.reload()}
        >
          {a.reload}
        </Button>
      }
    />
  );
}

/**
 * Zoals `lazy` van preact-iso, maar een mislukte import (oud stukje code na een uitrol, of geen
 * netwerk) laat de route niet leeg: één keer vanzelf herladen, anders een foutmelding met knop.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- elk scherm heeft eigen props
export function lazyPage<T extends ComponentType<any>>(load: () => Promise<T>): T {
  return lazy<T>(() =>
    loadOrFallback<T>(load, {
      // De vervangers negeren de props van het scherm.
      whileReloading: ReloadingPage as unknown as T,
      onError: ChunkErrorPage as unknown as T,
    }),
  );
}
